import sifarishRoutes from "./public/SifarishRoutes"

export default prefix => ([
    ...sifarishRoutes(`${prefix}/sifarish`),
])
